// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__4ZWvd","main":"style_main__k1Oih","imageWrapper":"style_imageWrapper__siYTr","content":"style_content__wILLb","cell":"style_cell__s4YqB"};